import i18n from 'i18next';
import { GetCookie } from './core/utils/cookies';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en.json';
import esTranslation from './locales/es.json';
import deTranslation from './locales/de.json';
import frTranslation from './locales/fr.json';
import itTranslation from './locales/it.json';
import plTranslation from './locales/pl.json';
import ptTranslation from './locales/pt.json';
import trTranslation from './locales/tr.json';
import arTranslation from './locales/ar.json';
import svTranslation from './locales/sv.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  es: {
    translation: esTranslation,
  },
  de: {
    translation: deTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  it: {
    translation: itTranslation,
  },
  pl: {
    translation: plTranslation,
  },
  pt: {
    translation: ptTranslation,
  },
  tr: {
    translation: trTranslation,
  },
  ar: {
    translation: arTranslation,
  },
  sv: {
    translation: svTranslation,
  },
};

const getLanguageFromCookie = () => {
  let cookieValue = document.cookie
    .split('; ')
    .find(row => row.startsWith('locales='))
    ?.split('=')[1];

    if (!cookieValue) {
      cookieValue = GetCookie("locales") ? GetCookie("locales") : "";
    }

  if (cookieValue) {
    if (cookieValue === 'fr'
      || cookieValue === 'de'
      || cookieValue === 'es'
      || cookieValue === 'tr'
      || cookieValue === 'pt'
      || cookieValue === 'it'
      || cookieValue === 'pl'
      || cookieValue === 'en'
      || cookieValue === 'ar'
      || cookieValue === 'sv'
    ) {
      return cookieValue;
    } else {
      return 'en';
    }
  }

  return 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguageFromCookie(),  // Default language
    fallbackLng: 'en', // Fallback language
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
